/* eslint-disable react/no-unescaped-entities */
// 平台操作日志页面

import React, {
  Component,
} from "react";
import ScGridTable from "@/components/display/table/gridTableCore";
import { aliListLogstore, aliGetLogs, prefixFile } from "@/fetch/fetchApi";
import FormCore from "@/components/display/form/formCore";
import moment from "moment";
import PropTypes from "prop-types";

import { Popover } from "antd";
import RefreshGrid from "@/utils/refreshGrid";
import {
  QuestionCircleOutlined,
} from "@ant-design/icons";
import "@/assets/stylus/oprationLog.styl";
// 引入页面
import noPic from "@/assets/img/notsearch.png";
// 国际化切换语言
import { connect } from "react-redux";
import { injectIntl } from "react-intl";

// eslint-disable-next-line arrow-parens
@connect(state => state)
class OprationLog extends Component {
  constructor(props) {
    super(props);
    this.props = props;
    this.internationalization = this.props.intl.messages.stubList;
    // 设置查询条件
    this.query = {

    };
    if (window.LayoutTab && window.LayoutTab.tabParam) {
      this.query["query"] = window.LayoutTab.tabParam.stubId; //  +' and '+window.LayoutTab.tabParam.orderId;
      this.query["startTime"] = window.LayoutTab.tabParam.startTime;
      this.query["endTime"] = window.LayoutTab.tabParam.endTime === "--" ? window.LayoutTab.tabParam.startTime : window.LayoutTab.tabParam.endTime;
    }
    console.log(this.query);
    this.state = {
      query: this.query.query ? this.query.query : "",
      startTime: this.query.startTime ? this.query.startTime : "",
      endTime: this.query.endTime ? this.query.endTime : "",
      showNotSearch: !this.query.query,
    };
    console.log(this.state.showNotSearch);
  }

    static contextTypes = {
      store: PropTypes.object.isRequired,
    };

    // 页面加载前方法
    componentWillMount() {
      this.setState({
        formConfig: this.initForm(),
      });
      this.initTable();
    }

    // 页面加载完成方法
    componentDidMount() {
      if (this.state.query) {
        this.fetchApi({
          // page: 1,
          // pageCount: 10,
          project: "iot-ccchong-com",
          logstorename: "iot21-log",
          date: this.query.startTime ? `${moment(this.query.startTime).format("YYYY-MM-DD HH:mm:ss")},${moment(this.query.endTime).format("YYYY-MM-DD HH:mm:ss")}` : `${moment(new Date()).subtract(7, "d").format("YYYY-MM-DD HH:mm:ss")},${moment(new Date()).format("YYYY-MM-DD HH:mm:ss")}`,
          ...this.query,
          startTime: undefined,
          endTime: undefined,
        });
      }
    }

    // 加载form方法
    initForm() {
      const formConfig = {
        childItems: [{
          type: "input",
          placeholder: "关键字",
          width: "100%",
          param: {
            name: "query",
            type: "string",
          },
          labelName: "关键字",
          defaultValue: this.state.query,
          required: false,
          suffix: (
            <Popover content={(
              <div>
                <div>查询:</div>
                <div>1. 全文查询：error</div>
                <div>2. 指定字段查询：Latency{">"}5000 and Method:Get* and not Status:200</div>
                <div>3. 短语（指定引号）："http error"</div>
                <br />
                <div>分析:</div>
                <div>1. 无查询条件：* | $analytics</div>
                <div>2. 带查询条件：$search | $analytics</div>
                <br />
                <div>查询语法：<a target="_blank" rel='noreferrer noopener' href='https://help.aliyun.com/document_detail/29060.html?spm=5176.doc29029.2.3.4jvt6H'>查询语法</a></div>
                <div>如若查询异常请<a target="_blank" rel='noreferrer noopener' href='https://help.aliyun.com/document_detail/61628.html?spm=5176.2020520112.0.0.239334c0NUGARn'>查看帮助</a></div>
              </div>
                )}>
              <QuestionCircleOutlined />
            </Popover>),
        },
        {
          type: "select",
          placeholder: "请选择日志类型",
          labelName: "日志类型",
          param: {
            name: "logstorename",
            type: "string",
          },
          defaultValue: "iot21-log",
          dataApi: {
            api: aliListLogstore,
          },
          fetchQuery: {
            project: "iot-ccchong-com",
          },
          required: true,
        },
        {
          type: "date",
          dateType: "rangeDateTime",
          placeholder: ["年/月/日 时:分:秒", "年/月/日 时:分:秒"],
          param: {
            name: "date",
            type: "array",
          },
          allowClear: false,
          defaultValue: (this.state.startTime === "" && this.state.endTime === "") ? [moment(new Date()).subtract(7, "d"), moment(new Date())] : [moment(this.state.startTime), moment(this.state.endTime)],
          validator: { // 日期自定义校验规则
            vtype: "date", // 校验名称
            min_val: 0, // 可选最小天数
          }, // 自定义校验规则
          labelName: "查询时间",
          required: true,
        },
        {
          type: "buttonGp", // 表单最终执行组
          buttonArr: [{
            btnType: "submit",
            text: "查询",
            // icon: 'search'
          },
          {
            btnType: "button",
            text: "导出",
            icon: "export",
            handler: (e, param) => {
              this.exportData(param);
            },
          },
          ],
        }],
        layout: "inline", // 设置布局 0： 横向布局， 1：弹窗布局 2： 全页表单布局
        formTarget: "submit", // 表单提交类型，设置grid则为更新grid
        defaultParams: {
          project: "iot-ccchong-com",

        },
        autoLoadGrid: false, // 设置为false不触发加载grid
        context: this,
        tableKey: "oprationLogTable",
      };

      return formConfig;
    }

    // 加载表格方法
    initTable() {
      // 表格初始化方法
      this.setState({
        tableConfig: {
          tableColumns: [{
            name: "时间",
            key: "logTimeFmt",
            width: "300px",
            align: "left",
            colType: "textCol",
          }, {
            name: "Source",
            key: "source",
            width: "300px",
            align: "left",
            colType: "textCol",
          }, {
            name: "内容",
            key: "logDetails",
            align: "left",
            colType: "textCol",
            render: (value, row) => {
              // let contentMap = [];
              // let count = row.logTags.length+1

              // contentMap.push(...row.logTags)
              // contentMap.push(row.logDetails)

              // let content = contentMap.map((item,index) =>{
              //     count++
              //     return <div style={{wordBreak:'normal'}}>{item}</div>
              // })

              // return <div style={{textAlign:'left'}}>{content}</div>
              return <div style={{ textAlign: "left" }}>{row.logDetails}</div>;
            },
          }],
          tableParam: {
            pageCount: 10,
          },
          tableInfo: {
            hasRow: !1, // 是否显示checkbox
          },
          tableChange: () => {
            // grid翻页页，排序， 筛选过滤时触发
            console.debug("change");
          },
          autoRefresh: false, // 设置为true 直接加载grid数据
          tableKey: "oprationLogTable",
          dataApi: aliGetLogs,
        },
      });
    }

    /**
     * 表格数据加载方法
     */
    fetchApi = (param) => {
      this.setState({
        showNotSearch: false,
      });
      const newParam = param;
      const date = newParam.date.split(",");
      newParam.startDate = date[0];
      newParam.endDate = date[1];
      delete newParam.date;
      console.log(this.props);

      // 如果正常页面中的表单提交，请执行下面
      return RefreshGrid(this.context.store, "oprationLogTable", newParam);
    };

    // 数据导出
    exportData(param) {
      const excelUrl = `${prefixFile}/aliLogExport.do`;

      param.locale = this.props.intl.locale;

      const date = param.date.split(",");
      param.startDate = date[0];
      param.endDate = date[1];
      delete param.date;

      let params = "";
      Object.keys(param).forEach((key) => {
        if (param[key] !== undefined) {
          params += `${key}=${param[key]}&`;
        }
      });

      const ele = document.createElement("a");
      ele.download = encodeURI(`${excelUrl}?${params}`);
      ele.style.display = "none";
      ele.href = encodeURI(`${excelUrl}?${params}`);
      ele.target = "_blank"; // 针对 ie模式 的浏览器
      // 触发点击
      document.body.appendChild(ele);
      ele.click();
      // 然后移除
      document.body.removeChild(ele);
    }

    render() {
      console.log(this.state.showNotSearch);
      const content = (
        <div className="sc-page-content oprationLogTable">
          <div className="page-toolbar">
            <FormCore formConfig={this.state.formConfig} fetchApi={this.fetchApi} />
          </div>
          <div className="page-panel">
            <ScGridTable config={this.state.tableConfig} />
            {this.state.showNotSearch ? (
              <div className="not-search-tip">
                <img alt="" src={noPic} />
                <div className="nosearchWZ">
                  <div className="wz1">暂无数据</div>
                  <div className="wz2">抱歉，页面暂无数据，请输入筛选条件后查询</div>
                </div>
              </div>

            ) : null}
          </div>

        </div>);
      return content;
    }
}

export default injectIntl(OprationLog);



// WEBPACK FOOTER //
// ./src/AntD/pages/oprationLog/oprationLog.js